import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button, Box, CircularProgress, Typography} from 'views/components';
import {Translate} from 'views/module';

import MessageFeedBox from './MessageFeedBox';

const MessageFeed = (props) => {
  const {
    jobRn,
    jobMessages,
    jobMessagesLoading,
    jobMessagesLastEvaluatedKey,
    sortDir,
    messageTypeFilter,
    jobBackend,
  } = props;

  const loadMoreMessages = () => {
    if (jobMessagesLastEvaluatedKey && !jobMessagesLoading) {
      jobBackend.load.loadMessages(jobRn, jobMessagesLastEvaluatedKey);
    }
  };

  const messagesToDisplay = React.useMemo(() => {
    return Object.values(jobMessages)
        .filter((message) => messageTypeFilter[message.messageType])
        .sort((a, b) => {
          const dateA = new Date(a.createdAt);
          const dateB = new Date(b.createdAt);

          if (sortDir === 'DESC') {
            return dateB - dateA;
          }

          return dateA - dateB;
        });
  }, [jobMessages, messageTypeFilter, sortDir]);

  const showLoadMoreButton = jobMessagesLastEvaluatedKey && !jobMessagesLoading;
  const showLoadMoreSection = jobMessagesLoading || showLoadMoreButton;
  const loadMoreSection = (
    <Stack
      spacing={2}
      sx={{
        alignItems: 'center',
      }}
    >
      {
        jobMessagesLoading &&
        <CircularProgress/>
      }
      {
        showLoadMoreButton &&
        <Button
          color={'primary'}
          onClick={loadMoreMessages}
        >
          <Translate expression={'career.jobDetail.Messages.LoadMore'} />
        </Button>
      }
    </Stack>
  );

  return (
    <Stack
      spacing={2.5}
      sx={{
        px: {md: 2.5, xs: 1.5},
        pt: 2.5,
        pb: 2,
      }}
    >
      {
        sortDir === 'ASC' && showLoadMoreSection && loadMoreSection
      }
      <Stack spacing={2.5}>
        {
          messagesToDisplay.length === 0 && !jobMessagesLoading &&
          <Box px={2} py={1}>
            <Typography color="text.secondary" align="center">
              <Translate expression="career.jobDetail.Messages.Empty" />
            </Typography>
          </Box>
        }
        {
          messagesToDisplay.map((message) => (
            <MessageFeedBox
              key={message.messageRn}
              message={message}
              jobBackend={jobBackend}
            />
          ))
        }
      </Stack>
      {
        sortDir === 'DESC' && showLoadMoreSection && loadMoreSection
      }
    </Stack>
  );
};

MessageFeed.propTypes = {
  jobRn: PropTypes.string.isRequired,
  jobMessages: PropTypes.object.isRequired,
  jobMessagesLoading: PropTypes.bool.isRequired,
  jobMessagesLastEvaluatedKey: PropTypes.string,
  sortDir: PropTypes.string.isRequired,
  messageTypeFilter: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
  }).isRequired,
  jobBackend: PropTypes.object.isRequired,
};

export default React.memo(MessageFeed);
